/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Edycja ukończona',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Wprowadź zmiany',
  'editor-common-extensibility.macro.button.configure': 'Skonfiguruj makro {macroName}',
  'fablric.editor.viewAllInserts': 'Wyświetl wszystkie wstawiane elementy',
  'fabric.editor.action': 'Element akcji',
  'fabric.editor.action.description': 'Utwórz i przypisz elementy akcji',
  'fabric.editor.addAltText': 'Tekst alternatywny',
  'fabric.editor.addColumnLeft': 'Dodaj kolumnę z lewej',
  'fabric.editor.addColumnRight': 'Dodaj kolumnę z prawej',
  'fabric.editor.addCommentOnMedia': 'Dodaj komentarz',
  'fabric.editor.addImageBorder': 'Dodaj obramowanie',
  'fabric.editor.addLoomVideo': 'Nagraj film Loom',
  'fabric.editor.addLoomVideoComment': 'Nagraj komentarz wideo Loom',
  'fabric.editor.addMediaFiles': 'Dodaj obraz, film lub plik',
  'fabric.editor.addRowAbove': 'Dodaj wiersz powyżej',
  'fabric.editor.addRowBelow': 'Dodaj wiersz poniżej',
  'fabric.editor.addUpdatedAltText': 'Dodaj tekst alternatywny',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Użyj Atlassian Intelligence, aby znaleźć czynności do wykonania i wyświetlić je w panelu',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Panel czynności do wykonania (wersja beta)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Użyj Atlassian Intelligence, aby utworzyć podsumowanie tej strony i wyświetlić je w panelu',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Panel podsumowania strony (wersja beta)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Wybrane treści',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Generuje treści do wstawienia do aktualizacji',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Podsumowuje treść aktualizacji',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Generuj',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Zapytaj Atlassian Intelligence',
  'fabric.editor.ai.config.item.action.insert': 'Wstaw',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Wstaw na początku',
  'fabric.editor.ai.config.item.action.insertBelow': 'Wstaw poniżej',
  'fabric.editor.ai.config.item.action.replace': 'Zamień',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Zamień tytuł',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Długość tytułu nie może przekraczać {maxLength} znaków',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Otwórz na czacie',
  'fabric.editor.ai.config.item.agent.title': 'Agent Rovo Atlassian Intelligence',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Skraca treść, aby była bardziej zwięzła.',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Skróć treść komunikatu',
  'fabric.editor.ai.config.item.bb.pr.description.description': 'Tworzy opis pull requestu wraz z podsumowaniem zmian.',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Utwórz opis pull requestu',
  'fabric.editor.ai.config.item.brainstorm.description': 'Generuje listę pomysłów na podany temat.',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Podaj mi temat…',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Burza mózgów',
  'fabric.editor.ai.config.item.brainstorm.title': 'Burza mózgów',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Zmienia styl treści na swobodny.',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Swobodny',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Swobodny',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Zmień styl na swobodny',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Zmienia styl treści na edukacyjny.',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Edukacyjny',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Edukacyjny',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Zmień styl na edukacyjny',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Zmienia styl treści na empatyczny.',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empatyczny',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empatyczny',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Zmień styl na empatyczny',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Zmień styl na…',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Zmienia styl treści na neutralny.',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutralny',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutralny',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Zmień styl na neutralny',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description': 'Zmienia styl treści na profesjonalny.',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Profesjonalny',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Profesjonalny',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Zmień styl na profesjonalny',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'Przekształca treść w listę wypunktowaną.',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'Konwertuj na listę wypunktowaną',
  'fabric.editor.ai.config.item.convertToTable.description': 'Przekształca treść w tabelę z nagłówkami.',
  'fabric.editor.ai.config.item.convertToTable.title': 'Konwertuj na tabelę',
  'fabric.editor.ai.config.item.draftReply.description':
    'Przygotowuje odpowiedź na podstawie zgłoszeń podobnych do tego, nad którym pracujesz.',
  'fabric.editor.ai.config.item.draftReply.title': 'Przygotuj odpowiedź',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Poprawia pisownię i gramatykę.',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title': 'Pisownia i gramatyka',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Popraw pisownię i gramatykę',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Poprawia czytelność, konstrukcję i styl, zwiększając atrakcyjność i zrozumiałość tekstu.',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': 'Popraw styl',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Popraw styl',
  'fabric.editor.ai.config.item.findActionItems.description': 'Znajduje czynności do wykonania w podanej treści.',
  'fabric.editor.ai.config.item.findActionItems.title': 'Znajdź czynności do wykonania',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Wybierz z poniższych opcji (samodzielnie generowane polecenia są obecnie wyłączone w Elevate)',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'Napisz za pomocą AI lub wybierz jedną z poniższych opcji',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Zmień strukturę opisu zgłoszenia na podstawie typu zgłoszenia.',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Popraw opis',
  'fabric.editor.ai.config.item.makeLonger.description': 'Rozbudowuje treść, bazując na podanym kontekście.',
  'fabric.editor.ai.config.item.makeLonger.title': 'Rozbuduj',
  'fabric.editor.ai.config.item.range.agent.description': 'Brak opisu',
  'fabric.editor.ai.config.item.range.agent.prompt.hint': 'Poproś agenta o napisanie czegoś lub wybierz opcję poniżej',
  'fabric.editor.ai.config.item.rephrase.description': 'Tworzy sugestie dotyczące przeredagowania zdań.',
  'fabric.editor.ai.config.item.rephrase.title': 'Przeformułuj',
  'fabric.editor.ai.config.item.shorten.description': 'Skraca treść, aby była bardziej zwięzła.',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Skróć',
  'fabric.editor.ai.config.item.shorten.title': 'Skróć',
  'fabric.editor.ai.config.item.suggest.description': 'Sugeruje tytuł podanej treści.',
  'fabric.editor.ai.config.item.suggest.title': 'Zaproponuj tytuł',
  'fabric.editor.ai.config.item.summarize.description':
    'Tworzy podsumowanie tekstu, nad którym pracujesz, i wyróżnia najważniejsze punkty.',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Podsumuj tekst',
  'fabric.editor.ai.config.item.summarize.title': 'Podsumuj tekst',
  'fabric.editor.ai.config.item.translate.czech': 'Czeski',
  'fabric.editor.ai.config.item.translate.danish': 'Duński',
  'fabric.editor.ai.config.item.translate.dutch': 'Holenderski',
  'fabric.editor.ai.config.item.translate.english': 'Angielski',
  'fabric.editor.ai.config.item.translate.finnish': 'Fiński',
  'fabric.editor.ai.config.item.translate.french': 'Francuski',
  'fabric.editor.ai.config.item.translate.german': 'Niemiecki',
  'fabric.editor.ai.config.item.translate.hungarian': 'Węgierski',
  'fabric.editor.ai.config.item.translate.italian': 'Włoski',
  'fabric.editor.ai.config.item.translate.japanese': 'Japoński',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Przetłumacz',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Przetłumacz na…',
  'fabric.editor.ai.config.item.translate.norwegian': 'Norweski',
  'fabric.editor.ai.config.item.translate.russian': 'Rosyjski',
  'fabric.editor.ai.config.item.translate.spanish': 'Hiszpański',
  'fabric.editor.ai.config.item.translate.swedish': 'Szwedzki',
  'fabric.editor.ai.config.item.translate.thai': 'Tajski',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Tłumaczy tekst, nad którym pracujesz, na język chiński (uproszczony)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Przetłumacz na chiński (uproszczony)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Tłumaczy tekst, nad którym pracujesz, na język chiński (tradycyjny)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Przetłumacz na chiński (tradycyjny)',
  'fabric.editor.ai.config.item.translateTo.czech.description': 'Tłumaczy tekst, nad którym pracujesz, na język czeski',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Przetłumacz na czeski',
  'fabric.editor.ai.config.item.translateTo.danish.description':
    'Tłumaczy tekst, nad którym pracujesz, na język duński',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Przetłumacz na duński',
  'fabric.editor.ai.config.item.translateTo.dutch.description':
    'Tłumaczy tekst, nad którym pracujesz, na język holenderski',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Przetłumacz na holenderski',
  'fabric.editor.ai.config.item.translateTo.english.description':
    'Tłumaczy tekst, nad którym pracujesz, na język angielski',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Przetłumacz na angielski',
  'fabric.editor.ai.config.item.translateTo.finnish.description':
    'Tłumaczy tekst, nad którym pracujesz, na język fiński',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Przetłumacz na fiński',
  'fabric.editor.ai.config.item.translateTo.french.description':
    'Tłumaczy tekst, nad którym pracujesz, na język francuski',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Przetłumacz na francuski',
  'fabric.editor.ai.config.item.translateTo.german.description':
    'Tłumaczy tekst, nad którym pracujesz, na język niemiecki',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Przetłumacz na niemiecki',
  'fabric.editor.ai.config.item.translateTo.hungarian.description':
    'Tłumaczy tekst, nad którym pracujesz, na język węgierski',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Przetłumacz na węgierski',
  'fabric.editor.ai.config.item.translateTo.italian.description':
    'Tłumaczy tekst, nad którym pracujesz, na język włoski',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Przetłumacz na włoski',
  'fabric.editor.ai.config.item.translateTo.japanese.description':
    'Tłumaczy tekst, nad którym pracujesz, na język japoński',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Przetłumacz na japoński',
  'fabric.editor.ai.config.item.translateTo.korean.description':
    'Tłumaczy tekst, nad którym pracujesz, na język koreański',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Przetłumacz na koreański',
  'fabric.editor.ai.config.item.translateTo.norwegian.description':
    'Tłumaczy tekst, nad którym pracujesz, na język norweski',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Przetłumacz na norweski',
  'fabric.editor.ai.config.item.translateTo.polish.description':
    'Tłumaczy tekst, nad którym pracujesz, na język polski',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Przetłumacz na polski',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Tłumaczy tekst, nad którym pracujesz, na język portugalski (brazylijski)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Przetłumacz na portugalski (brazylijski)',
  'fabric.editor.ai.config.item.translateTo.russian.description':
    'Tłumaczy tekst, nad którym pracujesz, na język rosyjski',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Przetłumacz na rosyjski',
  'fabric.editor.ai.config.item.translateTo.spanish.description':
    'Tłumaczy tekst, nad którym pracujesz, na język hiszpański',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Przetłumacz na hiszpański',
  'fabric.editor.ai.config.item.translateTo.swedish.description':
    'Tłumaczy tekst, nad którym pracujesz, na język szwedzki',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Przetłumacz na szwedzki',
  'fabric.editor.ai.config.item.translateTo.thai.description': 'Tłumaczy tekst, nad którym pracujesz, na język tajski',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Przetłumacz na tajski',
  'fabric.editor.ai.config.item.translateTo.turkish.description':
    'Tłumaczy tekst, nad którym pracujesz, na język turecki',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Przetłumacz na turecki',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Tłumaczy tekst, nad którym pracujesz, na język ukraiński',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Przetłumacz na ukraiński',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Tłumaczy tekst, nad którym pracujesz, na język wietnamski',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Przetłumacz na wietnamski',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Zmień styl',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Przeredaguj',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Przetłumacz',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Tytuł strony',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Strona',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Wystąpiły problemy podczas wstawienia odpowiedzi. Zamknij okno dialogowe i spróbuj ponownie.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'Wystąpiły problemy podczas generowania podglądu. Zamknij okno dialogowe i spróbuj ponownie.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'Ostatnio otrzymaliśmy zbyt wiele żądań do Atlassian Intelligence (AI). Spróbuj ponownie za kilka minut lub przeczytaj o <link>nadmiernym wykorzystaniu AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Nie można pobrać odpowiedzi. Twoja podpowiedź lub odpowiedź przekroczyła limit tego żądania. Zamknij okno dialogowe i spróbuj ponownie.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'Wystąpiły problemy. Zamknij okno dialogowe i spróbuj ponownie.',
  'fabric.editor.ai.experience.apiError': 'Nie można uzyskać odpowiedzi. Spróbuj ponownie.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Twoje polecenie lub treść może nie być zgodne z naszymi Zasadami dopuszczalnego użytkowania. Przejrzyj je i w razie potrzeby zapoznaj się z naszymi <link>Zasadami dopuszczalnego użytkowania</link>. Jeśli problem nie ustąpi, rozważ wypróbowanie innego polecenia lub treści.',
  'fabric.editor.ai.experience.browseMore.agents': 'Przeglądaj agenty',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Czy chcesz odrzucić podpowiedź?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Czy chcesz odrzucić odpowiedź?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError':
    'Samodzielnie generowane podpowiedzi są obecnie wyłączone w Elevate.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Możesz teraz wklejać łącza 🔗 do zawartości Jiry i Confluence w swoich poleceniach.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Obsługiwane przez Rovo',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence nie może przetworzyć Twojego żądania, ponieważ treść zawiera łącza do zawartości podlegających ograniczeniom przepisów HIPAA. Usuń te łącza i spróbuj ponownie.',
  'fabric.editor.ai.experience.inputTooShortError':
    'Treść jest za krótka, aby ją podsumować. Dodaj więcej i spróbuj ponownie.',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) nie odpowiada. Spróbuj ponownie później lub <link>sprawdź status AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Generowanie',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analizowanie: weryfikowanie pytania.',
  'fabric.editor.ai.experience.messageTemplateContentSearch': 'Wyszukiwanie: Zaczekaj chwilę. Wyszukujemy informacje.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask':
    'Wyszukiwanie: Zaczekaj chwilę. Przeszukujemy system Jira.',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'Wyszukiwanie: Zaczekaj chwilę. Przeszukujemy stronę.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Brak wyników',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Atlassian Intelligence nie ma obecnie żadnych sugestii. Zachęcamy do wypróbowania innej podpowiedzi lub treści.',
  'fabric.editor.ai.experience.showMoreButton': 'Pokaż więcej',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Czynności',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agenci',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Źródło wiedzy',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Agenty Rovo',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Agenty Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Użyj agenta Rovo ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Użyj wiedzy ogólnej',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Użyj wiedzy z organizacji',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'Wystąpiły problemy podczas generowania podglądu. Zamknij okno dialogowe i spróbuj ponownie.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage':
    'Wystąpiły problemy. Zamknij okno dialogowe i spróbuj ponownie.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Wstaw poniżej',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Zamień',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Żądania generowania treści odwołujące się do adresów URL znajdują się w wersji beta.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': 'Wyróżnij termin, akronim lub skrót',
  'fabric.editor.ai.selectionToolbar.define.title': 'Podaj definicję',
  'fabric.editor.ai.toolbar.askAI.title': 'Zapytaj AI',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Popraw styl',
  'fabric.editor.ai.toolbar.improveWriting.tooltip': 'Poproś Atlassian Intelligence o poprawienie wybranego tekstu',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.tryAI.title': 'Wypróbuj AI',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Otwórz Atlassian Intelligence',
  'fabric.editor.alignCenter': 'Wyrównaj do środka',
  'fabric.editor.alignImageCenter': 'Wyrównaj do środka',
  'fabric.editor.alignImageLeft': 'Wyrównaj do lewej',
  'fabric.editor.alignImageRight': 'Wyrównaj do prawej',
  'fabric.editor.alignLeft': 'Wyrównaj do lewej',
  'fabric.editor.alignRight': 'Wyrównaj do prawej',
  'fabric.editor.alignTableCenter': 'Wyrównaj do środka',
  'fabric.editor.alignTableLeft': 'Wyrównaj do lewej',
  'fabric.editor.alignment': 'Wyrównanie tekstu',
  'fabric.editor.altText': 'Tekst alternatywny',
  'fabric.editor.alttext.validation': 'Usuń wszystkie znaki specjalne z tekstu alternatywnego.',
  'fabric.editor.annotationToolbar': 'Pasek narzędzi adnotacji',
  'fabric.editor.backLink': 'Wróć',
  'fabric.editor.backgroundColor': 'Kolor tła',
  'fabric.editor.blockCardUnavailable':
    'Łącze bezpośrednio w tekście jest wewnątrz węzła {node} i nie można zmienić jego widoku',
  'fabric.editor.blockControlDelete': 'Usuń',
  'fabric.editor.blockControlDragHandleMove': 'Przeciągnij, aby przenieść',
  'fabric.editor.blockControlDragHandleRearrange': 'Przeciągnij, aby zmienić kolejność',
  'fabric.editor.blockControlInsert': 'Wstaw',
  'fabric.editor.blockControlMoveDown': 'Przenieś niżej',
  'fabric.editor.blockControlMoveLeft': 'Przenieś w lewo',
  'fabric.editor.blockControlMoveRight': 'Przenieś w prawo',
  'fabric.editor.blockControlMoveUp': 'Przenieś wyżej',
  'fabric.editor.blockControlMovedDown': 'Zawartość została przeniesiona w dół',
  'fabric.editor.blockControlMovedUp': 'Zawartość została przeniesiona w górę',
  'fabric.editor.blockDescription': 'Wyświetla więcej informacji o łączu, w tym podsumowanie i czynności',
  'fabric.editor.blockTitle': 'Karta',
  'fabric.editor.blockquote': 'cudzysłów',
  'fabric.editor.blockquote.description': 'Wstaw cytat',
  'fabric.editor.blockquote2': 'Cytat',
  'fabric.editor.bold': 'Pogrubienie',
  'fabric.editor.bug': 'Błąd',
  'fabric.editor.canNotSortTable': '⚠️ Nie można sortować tabeli ze scalonymi komórkami',
  'fabric.editor.cancelButton': 'Anuluj',
  'fabric.editor.captionPlaceholder': 'Dodaj podpis',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt': 'Dodaj podpis — kliknij dwukrotnie, aby wyświetlić podgląd',
  'fabric.editor.cardFloatingControls': 'Opcje kart',
  'fabric.editor.cellBackground': 'Tło komórki',
  'fabric.editor.cellOptions': 'Opcje komórki',
  'fabric.editor.checkUncheckActionItem': 'Przełącz czynność do wykonania',
  'fabric.editor.clearAltTextEdit': 'Wyczyść tekst alternatywny',
  'fabric.editor.clearCells':
    '{0, plural, one {Wyczyść komórkę} few {Wyczyść komórki} many {Wyczyść komórki} other {Wyczyść komórki}}',
  'fabric.editor.clearFormatting': 'Wyczyść formatowanie',
  'fabric.editor.clearLink': 'Wyczyść łącze',
  'fabric.editor.clearLinkText': 'Wyczyść tekst',
  'fabric.editor.closeAltTextEdit': 'Wstecz',
  'fabric.editor.closeFindReplaceDialog': 'Zamknij',
  'fabric.editor.closeHelpDialog': 'Zamknij okno dialogowe pomocy',
  'fabric.editor.code': 'Kod',
  'fabric.editor.code.on': '{textFormattingOff}, formatowanie kodu wł.',
  'fabric.editor.codeBidiWarningLabel':
    'Znaki dwukierunkowe zmieniają kolejność, w jakiej tekst jest renderowany. Może to zostać wykorzystane do ukrycia złośliwego kodu.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Skopiowano!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Kopiuj jako tekst',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Wyłącz zawijanie',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Włącz zawijanie',
  'fabric.editor.codeblock': 'Wstawka kodu',
  'fabric.editor.codeblock.description': 'Wyświetlaj kod z wyróżnioną składnią',
  'fabric.editor.collapseNode': 'Zwiń zawartość',
  'fabric.editor.collapseTable': 'Zwiń tabelę',
  'fabric.editor.columnDragHandle': 'Opcje kolumn',
  'fabric.editor.columnMovedLeft': 'Przesunięto kolumnę w lewo do {index} z {total}',
  'fabric.editor.columnMovedRight': 'Przesunięto kolumnę w prawo do {index} z {total}',
  'fabric.editor.columnSelected': 'Wybrano kolumnę {index} z {total}',
  'fabric.editor.columns': 'Układy',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {Wstaw {numberOfColumns} kolumnę o jednakowej szerokości} few {Wstaw {numberOfColumns} kolumny o jednakowej szerokości} many {Wstaw {numberOfColumns} kolumn o jednakowej szerokości} other {Wstaw {numberOfColumns} kolumny o jednakowej szerokości}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Wstaw układ 1-kolumnowy',
  'fabric.editor.columns.description': 'Uporządkuj swoją stronę, korzystając z sekcji',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {Wstawiono kolumnę} few {Wstawiono {count} kolumny} many {Wstawiono {count} kolumn} other {Wstawiono {count} kolumny}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {Usunięto kolumnę} few {Usunięto {count} kolumny} many {Usunięto {count} kolumn} other {Usunięto {count} kolumny}}',
  'fabric.editor.configFailedToLoad': 'Niepowodzenie ładowania',
  'fabric.editor.configPanel.cancel': 'Anuluj',
  'fabric.editor.configPanel.close': 'Zamknij',
  'fabric.editor.configPanel.customSelect.createOption': 'Utwórz',
  'fabric.editor.configPanel.dateRange.custom.from': 'Od',
  'fabric.editor.configPanel.dateRange.custom.to': 'Do',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Zwiń',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Rozwiń',
  'fabric.editor.configPanel.dateRange.option.custom': 'Niestandardowa',
  'fabric.editor.configPanel.documentation': 'Dokumentacja',
  'fabric.editor.configPanel.errorBoundary.note':
    'Poinformowaliśmy zespół. Wciąż możesz edytować i opublikować tę stronę, a także sprawdzić konsolę błędów, aby uzyskać więcej informacji.',
  'fabric.editor.configPanel.errorBoundary.title': 'Coś poszło nie tak.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio': 'Nie można połączyć isMultiple ze stylem: radio',
  'fabric.editor.configPanel.formType.addField': 'Dodaj pole',
  'fabric.editor.configPanel.formType.removeField': 'Usuń pole',
  'fabric.editor.configPanel.help': 'Potrzebujesz pomocy?',
  'fabric.editor.configPanel.invalid': 'Nieprawidłowe pole',
  'fabric.editor.configPanel.required': 'Pole wymagane',
  'fabric.editor.configPanel.submit': 'Wyślij',
  'fabric.editor.copiedToClipboard': 'Skopiowano!',
  'fabric.editor.copyToClipboard': 'Kopiuj',
  'fabric.editor.cornerControl': 'Zaznacz tablicę',
  'fabric.editor.createComment': 'Komentarz',
  'fabric.editor.createCommentDisabled':
    'Można komentować tylko tekst, nagłówki, emoji, daty, wzmianki, łącza i statusy.',
  'fabric.editor.createCommentInvalid': 'Możesz komentować tylko tekst i nagłówki',
  'fabric.editor.createCommentOnInlineNodeSpotlight.action': 'Rozumiem',
  'fabric.editor.createCommentOnInlineNodeSpotlight.body':
    'Możesz teraz dodawać komentarze do elementów śródwierszowych, takich jak łącza, daty, statusy i wzmianki.',
  'fabric.editor.customPanel': 'Panel niestandardowy',
  'fabric.editor.customPanel.description': 'Dodaj notatkę z emoji i kolorowym tłem',
  'fabric.editor.datasource.assetsObjects.description':
    'Wstawianie obiektów z Zasobów do Jira Service Management z wyszukiwaniem i filtrowaniem',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Zasoby',
  'fabric.editor.datasource.confluenceSearch': 'Wstawianie listy Confluence',
  'fabric.editor.datasource.confluenceSearch.description':
    'Wstawianie listy wyników wyszukiwania z Confluence z ulepszonym wyszukiwaniem, filtrowaniem i konfigurowaniem.',
  'fabric.editor.datasource.jiraIssue': 'Zgłoszenia Jira',
  'fabric.editor.datasource.jiraIssue.description':
    'Wstawianie zgłoszeń Jira z Jira Cloud z ulepszonym wyszukiwaniem, filtrowaniem i konfigurowaniem.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Wstawianie zgłoszeń Jiry z systemu Jira Cloud z ulepszonym wyszukiwaniem, filtrowaniem i konfigurowaniem.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Zgłoszenia Jira',
  'fabric.editor.datasourceAppearanceTitle': 'Lista',
  'fabric.editor.datasourceTitle': 'Edytuj zapytanie wyszukiwania',
  'fabric.editor.date': 'Data',
  'fabric.editor.date.description': 'Dodaj datę, korzystając z kalendarza',
  'fabric.editor.decision': 'Decyzja',
  'fabric.editor.decision.description': 'Obserwuj decyzje, aby łatwo je śledzić',
  'fabric.editor.decisionPlaceholder': 'Dodaj decyzję…',
  'fabric.editor.decreaseSize': 'Zmniejsz rozmiar tabeli lub multimediów',
  'fabric.editor.defaultAltText': 'Dokument',
  'fabric.editor.delete': 'Usuń',
  'fabric.editor.description': 'Opis',
  'fabric.editor.displayBlock': 'Wyświetl kartę',
  'fabric.editor.displayEmbed': 'Wyświetl obiekt osadzony',
  'fabric.editor.displayInline': 'Wyświetl bezpośrednio w tekście',
  'fabric.editor.displayLink': 'Wyświetl jako tekst',
  'fabric.editor.displayOptionUnavailableInParentNode': 'Ta opcja wyświetlania nie jest dostępna w węźle {node}',
  'fabric.editor.displayText': 'Wyświetlany tekst',
  'fabric.editor.distributeColumns': 'Wyrównaj kolumny',
  'fabric.editor.dropPlaceholderLabel': 'Dokument',
  'fabric.editor.ecombedDescription': 'Wyświetl interaktywny podgląd łącza',
  'fabric.editor.edit': 'Edytuj',
  'fabric.editor.edit.datasource': 'Edytuj zapytanie wyszukiwania',
  'fabric.editor.edit.searchInput': 'Dodaj łącze',
  'fabric.editor.editAccessTitle': 'Potrzebujesz dostępu do edycji',
  'fabric.editor.editAltText': 'Edytuj tekst alternatywny',
  'fabric.editor.editDatasourceStandalone': 'Edytuj',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Edytuj zapytanie wyszukiwania',
  'fabric.editor.editDateText': 'Edytuj datę',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Edytuj zapytanie wyszukiwania',
  'fabric.editor.editDropdownEditLinkTitle': 'Edytuj łącze',
  'fabric.editor.editDropdownExpandIconLabel': 'Rozwiń menu rozwijane',
  'fabric.editor.editDropdownTriggerTitle': 'Edytuj',
  'fabric.editor.editLink': 'Edytuj łącze',
  'fabric.editor.editMode.inviteToEditButton.title': 'Zaproś do edycji',
  'fabric.editor.editStatusColor': 'Edytuj kolor statusu',
  'fabric.editor.editStatusText': 'Edytuj status',
  'fabric.editor.editableContentLabel': 'Zawartość dostępna do edycji',
  'fabric.editor.editorHelp': 'Pomoc w edytorze',
  'fabric.editor.editors': 'Edytujący',
  'fabric.editor.elementBrowser.help': 'Pomoc',
  'fabric.editor.elementInsertSidePanel.title': 'Wstaw',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Administracja',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Wszystko',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Komunikacja',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Zawartość Confluence',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Programowanie',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Zawartość zewnętrzna',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formatowanie',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Multimedia',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Nawigacja',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Raportowanie',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Elementy wizualne i obrazy',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Brak wyników pasujących do wyszukiwania',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Spróbuj wyszukać inny termin lub zapoznaj się z nowymi aplikacjami do produktów Atlassian.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Poznaj sklep Atlassian Marketplace',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Brak wyników pasujących do wyszukiwania.} one {{count} sugestia dostępna domyślnie.} few {{count} sugestie dostępne domyślnie.} many {{count} sugestii dostępnych domyślnie.} other {{count} sugestii dostępnej domyślnie.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Brak wyników pasujących do wyszukiwania.} one {{count} sugestia dostępna dla wpisanego tekstu.} few {{count} sugestie dostępne dla wpisanego tekstu.} many {{count} sugestii dostępnych dla wpisanego tekstu.} other {{count} sugestii dostępnej dla wpisanego tekstu.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Enter',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Wyszukaj',
  'fabric.editor.elementbrowser.sidebar.heading': 'Przeglądaj',
  'fabric.editor.embedTitle': 'Osadź',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Używaj emoji, aby wyrażać pomysły 🎉 i emocje 😄',
  'fabric.editor.emptyLink': 'Wprowadź łącze.',
  'fabric.editor.emptySearchResults': 'Nie znaleziono żadnych wyników.',
  'fabric.editor.emptySearchResultsSuggestion': 'Kliknij przycisk {buttonName}, aby przeglądać wstawiane elementy.',
  'fabric.editor.epic': 'Epik',
  'fabric.editor.error': 'Błąd',
  'fabric.editor.errorPanel': 'Panel błędów',
  'fabric.editor.errorPanel.description': 'Wyróżniaj błędy kolorem',
  'fabric.editor.expand': 'Sekcja rozwijana',
  'fabric.editor.expand.description': 'Wstaw sekcję rozwijaną',
  'fabric.editor.expandAriaLabel': 'Nadaj tytuł tej sekcji rozwijanej',
  'fabric.editor.expandDefaultTitle': 'Kliknij tutaj, aby rozwinąć...',
  'fabric.editor.expandNode': 'Rozwiń zawartość',
  'fabric.editor.expandPlaceholder': 'Nadaj temu rozwinięciu tytuł...',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'Usunięcie rozszerzenia {nodeName} spowoduje uszkodzenie wszystkiego, co jest z nim połączone.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Usuwanie',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Usuń',
  'fabric.editor.extension.deleteElementTitle': 'Usuwanie elementu',
  'fabric.editor.extension.sourceNoTitledName': 'ten element',
  'fabric.editor.extensions.config-panel.save-indicator': 'Wszystkie zmiany są zawsze zapisywane automatycznie',
  'fabric.editor.externalExtensionsHeading': 'Aplikacje',
  'fabric.editor.externalMediaFile': 'Zewnętrzny plik multimedialny',
  'fabric.editor.failed_to_upload': 'Nie można przekazać',
  'fabric.editor.feedbackDialog': 'Prześlij opinię',
  'fabric.editor.feedbackDialog.description':
    'Opowiedz nam o swoich doświadczeniach podczas korzystania z nowego edytora',
  'fabric.editor.find': 'Znajdź',
  'fabric.editor.findNext': 'Znajdź następne',
  'fabric.editor.findPrevious': 'Znajdź poprzednie',
  'fabric.editor.findReplaceToolbarButton': 'Znajdź i zamień',
  'fabric.editor.fiveColumns': 'Układ 5-kolumnowy',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Anuluj',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Usuń także połączone elementy',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 połączony element)} few {{name} (+{amount,number} połączone elementy)} many {{name} (+{amount,number} połączonych elementów)} other {{name} (+{amount,number} połączonego elementu)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Czy na pewno chcesz to zrobić?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': 'Otwarto elementy sterujące przestawnego paska narzędzi',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Przestawny pasek narzędzi',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Opcje układu',
  'fabric.editor.floatingToolbar.scrollLeft': 'Przewiń w lewo',
  'fabric.editor.floatingToolbar.scrollRight': 'Przewiń w prawo',
  'fabric.editor.focusTableResizeHandle': 'Koncentracja na uchwycie zmiany rozmiaru tabeli',
  'fabric.editor.fourColumns': 'Układ 4-kolumnowy',
  'fabric.editor.headerColumn': 'Kolumna nagłówka',
  'fabric.editor.headerRow': 'Wiersz nagłówka',
  'fabric.editor.heading1': 'Nagłówek 1',
  'fabric.editor.heading1Description': 'Użyj tego do nagłówka najwyższego poziomu',
  'fabric.editor.heading2': 'Nagłówek 2',
  'fabric.editor.heading2Description': 'Użyj tego do kluczowych sekcji',
  'fabric.editor.heading3': 'Nagłówek 3',
  'fabric.editor.heading3Description': 'Użyj tego do podsekcji i nagłówków grup',
  'fabric.editor.heading4': 'Nagłówek 4',
  'fabric.editor.heading4Description': 'Użyj tego do nagłówków głębokich',
  'fabric.editor.heading5': 'Nagłówek 5',
  'fabric.editor.heading5Description': 'Użyj tego do grupowania elementów list',
  'fabric.editor.heading6': 'Nagłówek 6',
  'fabric.editor.heading6Description': 'Użyj tego do nagłówków niskiego poziomu',
  'fabric.editor.headingLink.ascOrderLabel': 'Sortuj kolumnę od Z do A',
  'fabric.editor.headingLink.descOrderLabel': 'Wyczyść sortowanie',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Błąd',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Zgłoszenie',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Zgłoszenie',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Strona',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Historyjka',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Zadanie',
  'fabric.editor.headingLink.invalidLabel': '⚠️ Nie można sortować tabeli ze scalonymi komórkami',
  'fabric.editor.headingLink.noOrderLabel': 'Sortuj kolumnę od A do Z',
  'fabric.editor.help': 'Pomoc',
  'fabric.editor.help.description': 'Przeglądaj wszystkie skróty klawiszowe i opcje Markdown',
  'fabric.editor.helpDialogTips': 'Naciśnij {keyMap}, aby szybko otworzyć okno dialogowe w dowolnym momencie',
  'fabric.editor.highlight': 'Kolor wyróżnienia',
  'fabric.editor.highlightColor': 'Przełącz paletę kolorów wyróżnienia',
  'fabric.editor.highlightFloatingToolbar': 'Wyróżnij',
  'fabric.editor.horizontalRule': 'Separator',
  'fabric.editor.horizontalRule.description': 'Oddziel treści linią poziomą',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Wklej lub wyszukaj łącze',
  'fabric.editor.hyperlink.searchLinkAriaDescription':
    'Sugestie będą pojawiały się poniżej w miarę wpisywania tekstu w polu',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {nie znaleziono wyników} one {znaleziono {count,number} wynik} few {znaleziono {count,number} wyniki} many {znaleziono {count,number} wyników} other {znaleziono {count,number} wyniku}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Tekst wyświetlany (opcjonalny)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Wklej lub wyszukaj łącze',
  'fabric.editor.image': 'Obraz',
  'fabric.editor.image.fullWidthLabel': 'Pełna szerokość',
  'fabric.editor.imageBorderBold': 'Pogrubiony',
  'fabric.editor.imageBorderColor': 'Kolor',
  'fabric.editor.imageBorderMedium': 'Średni',
  'fabric.editor.imageBorderOptions': 'Opcje obramowania',
  'fabric.editor.imageBorderSize': 'Rozmiar',
  'fabric.editor.imageBorderSubtle': 'Delikatny',
  'fabric.editor.improvement': 'Ulepszenie',
  'fabric.editor.increaseSize': 'Zwiększ rozmiar tabeli lub multimediów',
  'fabric.editor.indent': 'Zwiększ wcięcie',
  'fabric.editor.info': 'Informacje',
  'fabric.editor.infoPanel': 'Panel informacyjny',
  'fabric.editor.infoPanel.description': 'Wyróżnij informacje kolorem',
  'fabric.editor.inlineConfigureLink': 'Konfiguruj łącze',
  'fabric.editor.inlineDescription': 'Wyświetla łącze bezpośrednio w tekście',
  'fabric.editor.inlineGoToLink': 'Otwórz łącze',
  'fabric.editor.inlineOverlay': 'Konfiguruj',
  'fabric.editor.inlineTitle': 'Bezpośrednio w tekście',
  'fabric.editor.inputQueryAssistiveTxt':
    'Gdy są dostępne wyniki autouzupełniania, użyj strzałek w górę i w dół, aby je przeglądać, oraz klawisza Enter, aby wybrać. Użytkownicy obsługujący urządzenie dotykiem szukają opcji dotykiem lub gestami szybkiego przesuwania.',
  'fabric.editor.insertColumn': 'Wstaw kolumnę z prawej',
  'fabric.editor.insertColumnDrag': 'Wstaw kolumnę',
  'fabric.editor.insertMenu': 'Wstaw elementy',
  'fabric.editor.insertRightRail.close': 'Zamknij',
  'fabric.editor.insertRightRail.title': 'Wstaw',
  'fabric.editor.insertRow': 'Wstaw wiersz poniżej',
  'fabric.editor.insertRowDrag': 'Wstaw wiersz',
  'fabric.editor.insertTableColumn': 'Wstaw kolumnę tabeli',
  'fabric.editor.insertTableRow': 'Wstaw wiersz tabeli',
  'fabric.editor.invalidDateError': 'Wprowadź prawidłową datę',
  'fabric.editor.invalidLink': 'Wprowadź prawidłowe łącze.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Zaproś członka zespołu do produktu {productName}} trusted {Zaproś członka zespołu do produktu {productName}} other {Dodaj członka zespołu do produktu {productName}}}',
  'fabric.editor.italic': 'Kursywa',
  'fabric.editor.keyboardShortcuts': 'Skróty klawiszowe',
  'fabric.editor.layout.columnOption':
    '{count, plural, one {Kolumna} few {{count} kolumny} many {{count} kolumn} other {{count} kolumny}}',
  'fabric.editor.layout.controls.placeholder': 'Wpisz /, aby wstawić',
  'fabric.editor.layout.placeholder': 'Dodaj treści',
  'fabric.editor.layout.resizeLayout': 'Zmień rozmiar układu',
  'fabric.editor.layoutFixedWidth': 'Powrót do centrum',
  'fabric.editor.layoutFullWidth': 'Pełna szerokość',
  'fabric.editor.layoutStateFixedWidth': 'Wyśrodkowany',
  'fabric.editor.layoutStateFullWidth': 'Pełna szerokość',
  'fabric.editor.layoutStateWide': 'Szeroka',
  'fabric.editor.layoutWide': 'Szeroki widok',
  'fabric.editor.leftSidebar': 'Układ z paskiem bocznym po lewej',
  'fabric.editor.link': 'Łącze',
  'fabric.editor.link.description': 'Wstaw łącze',
  'fabric.editor.linkAddress': 'Adres łącza',
  'fabric.editor.linkPlaceholder': 'Wklej łącze',
  'fabric.editor.lists': 'Listy',
  'fabric.editor.listsFormat': 'Formatowanie listy',
  'fabric.editor.lockColumns': 'Stała szerokość kolumn',
  'fabric.editor.longEmptyNodePlaceholderText': 'Wpisz „/”, aby wstawić elementy.',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'Uwzględniaj wielkość liter',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Szerokość multimediów została zmniejszona do {newMediaWidth,number} piksela.} few {Szerokość multimediów została zmniejszona do {newMediaWidth,number} pikseli.} many {Szerokość multimediów została zmniejszona do {newMediaWidth,number} pikseli.} other {Szerokość multimediów została zmniejszona do {newMediaWidth,number} piksela.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Szerokość multimediów została zwiększona do {newMediaWidth,number} piksela.} few {Szerokość multimediów została zwiększona do {newMediaWidth,number} pikseli.} many {Szerokość multimediów została zwiększona do {newMediaWidth,number} pikseli.} other {Szerokość multimediów została zwiększona do {newMediaWidth,number} piksela.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Rozmiar multimediów zmniejszony do minimalnego',
  'fabric.editor.media.insert.cancel': 'Anuluj',
  'fabric.editor.media.insert.fileTabTitle': 'Plik',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Niestety nie można dodać obrazu, do którego prowadzi łącze. Pobierz obraz, a następnie przeciągnij i upuść na stronie.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Ten obraz może nie być widoczny dla innych z powodu ograniczeń źródła. Zamiast tego rozważ przekazanie pliku.',
  'fabric.editor.media.insert.insert': 'Wstaw',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Nieprawidłowe łącze',
  'fabric.editor.media.insert.linkTabTitle': 'Łącze',
  'fabric.editor.media.insert.loadPreview': 'Załaduj podgląd',
  'fabric.editor.media.insert.localFileErrorMessage': 'Nie można przekazać tego pliku.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Błąd przekazywania pliku. Sprawdź ścieżkę pliku lub połączenie sieciowe.',
  'fabric.editor.media.insert.mediaAlt': 'Podgląd przekazanego obrazu lub pliku wideo',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Selektor multimediów',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Wklej łącze, aby przekazać',
  'fabric.editor.media.insert.upload': 'Przekaż',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Rozmiar multimediów zwiększony do maksymalnego',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Zmień rozmiar',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Zamknij',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'Pole wprowadzania wysokości',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Wysokość',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Maks. szerokość {maxWidth} piks.',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Szerokość',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Maks. szerokość {maxWidth} piks.',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'Konwertuj na piksele',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Migruj z rozmiaru procentowego na rozmiar w pikselach',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Prześlij',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Weryfikacja szerokości nie powiodła się',
  'fabric.editor.mediaAddLink': 'Dodaj łącze',
  'fabric.editor.mediaFiles': 'Obraz, film lub plik',
  'fabric.editor.mediaFiles.description': 'Dodaj obrazy i inne pliki do strony',
  'fabric.editor.mediaGroupDeleteLabel': 'Usuń',
  'fabric.editor.media_change_mediainline_caption_warn': 'Śródwierszowy (podpis zostanie usunięty)',
  'fabric.editor.media_change_mediainline_default': 'Bezpośrednio w tekście',
  'fabric.editor.media_change_mediasingle': 'Oryginalny rozmiar',
  'fabric.editor.mention': 'Wzmianka',
  'fabric.editor.mention.description': 'Wspomnij o kimś, aby wysłać mu powiadomienie',
  'fabric.editor.mentionNode.label': 'Oznaczony użytkownik',
  'fabric.editor.mentionsAddLabel': 'Ikona dodawania',
  'fabric.editor.mentionsIconLabel': 'Wzmianka',
  'fabric.editor.mergeCells': 'Scal komórki',
  'fabric.editor.moreFormatting': 'Więcej opcji formatowania',
  'fabric.editor.moveColumnLeft':
    '{0, plural, one {Przesuń kolumnę w lewo} few {Przesuń kolumny w lewo} many {Przesuń kolumny w lewo} other {Przesuń kolumny w lewo}}',
  'fabric.editor.moveColumnRight':
    '{0, plural, one {Przesuń kolumnę w prawo} few {Przesuń kolumny w prawo} many {Przesuń kolumny w prawo} other {Przesuń kolumny w prawo}}',
  'fabric.editor.moveDownDown':
    '{0, plural, one {Przesuń wiersz w dół} few {Przesuń wiersze w dół} many {Przesuń wiersze w dół} other {Przesuń wiersze w dół}}',
  'fabric.editor.moveRowUp':
    '{0, plural, one {Przesuń wiersz w górę} few {Przesuń wiersze w górę} many {Przesuń wiersze w górę} other {Przesuń wiersze w górę}}',
  'fabric.editor.navigate.toolbar.editor': 'Przejdź do paska narzędzi edytora',
  'fabric.editor.navigate.toolbar.floating': 'Przejdź do przestawnego paska narzędzi',
  'fabric.editor.noResultsFound': 'Brak wyników',
  'fabric.editor.noSearchResults': 'Brak wyników wyszukiwania',
  'fabric.editor.normal': 'Normalny tekst',
  'fabric.editor.note': 'Uwaga',
  'fabric.editor.notePanel': 'Panel uwag',
  'fabric.editor.notePanel.description': 'Dodaj uwagę w kolorze',
  'fabric.editor.numberedColumn': 'Kolumna numerowana',
  'fabric.editor.off': '{formattingType} wył.',
  'fabric.editor.offlineErrorFallbackDescription': 'Spróbuj załadować stronę ponownie.',
  'fabric.editor.offlineErrorFallbackHeading': 'Coś poszło nie tak',
  'fabric.editor.on': '{formattingType} wł.',
  'fabric.editor.openCellOptions': 'Otwórz opcje komórki',
  'fabric.editor.openLink': 'Otwórz łącze na nowej karcie',
  'fabric.editor.orderedList': 'Lista numerowana',
  'fabric.editor.orderedList.description': 'Utwórz uporządkowaną listę',
  'fabric.editor.other': 'Inne...',
  'fabric.editor.outdent': 'Zmniejsz wcięcie',
  'fabric.editor.overflowMenuViewMore': 'Wyświetl więcej',
  'fabric.editor.pageActionsLabel': 'Czynności na stronie',
  'fabric.editor.panel': 'Panel',
  'fabric.editor.panel.backgroundColor': 'Kolor tła',
  'fabric.editor.panel.custom': 'Niestandardowy',
  'fabric.editor.panel.emoji': 'Dodaj emoji',
  'fabric.editor.panel.panelsGroup': 'Rodzaje paneli',
  'fabric.editor.pasteOptions': 'Opcje wklejania',
  'fabric.editor.pastePlainText': 'Wklej zwykły tekst',
  'fabric.editor.placeholderAltText': 'Opisz ten obraz przy użyciu tekstu alternatywnego',
  'fabric.editor.placeholderText': 'Tekst zastępczy',
  'fabric.editor.placeholderText.description': 'Wstaw na stronę tekst zastępczy',
  'fabric.editor.placeholderTextPlaceholder': 'Dodaj tekst zastępczy',
  'fabric.editor.plainText': 'Użyj zwykłego tekstu',
  'fabric.editor.preferencesLink': 'Preferencje dotyczące łączy',
  'fabric.editor.quickInsert': 'Szybkie wstawianie',
  'fabric.editor.recordLoomShortTitle': 'Nagraj',
  'fabric.editor.recordVideo': 'Nagraj film Loom',
  'fabric.editor.recordVideo.description': 'Nagraj i udostępnij ekran i przemyślenia',
  'fabric.editor.redo': 'Ponów',
  'fabric.editor.remove': 'Usuń',
  'fabric.editor.removeColumns':
    '{0, plural, one {Usuń kolumnę} few {Usuń kolumny} many {Usuń kolumny} other {Usuń kolumny}}',
  'fabric.editor.removeEmoji': 'Usuń emoji',
  'fabric.editor.removeImageBorder': 'Usuń obramowanie',
  'fabric.editor.removeRows':
    '{0, plural, one {Usuń wiersz} few {Usuń wiersze} many {Usuń wiersze} other {Usuń wiersze}}',
  'fabric.editor.replace': 'Zastąp',
  'fabric.editor.replaceAll': 'Zastąp wszystko',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {Zastąpiono {numberOfMatches,number} dopasowanie} few {Zastąpiono {numberOfMatches,number} dopasowania} many {Zastąpiono {numberOfMatches,number} dopasowań} other {Zastąpiono {numberOfMatches,number} dopasowania}}',
  'fabric.editor.replaceWith': 'Zamień na',
  'fabric.editor.requestToEdit': 'Wyślij wniosek o dostęp do edycji',
  'fabric.editor.requestToEditDescription': 'Gdy poprosisz o dostęp, właściciel strony otrzyma powiadomienie.',
  'fabric.editor.requestToEditDismiss': 'Zamknij',
  'fabric.editor.resultsCount': '{selectedMatchPosition} z {totalResultsCount}',
  'fabric.editor.richText': 'Użyj tekstu sformatowanego',
  'fabric.editor.rightSidebar': 'Układ z paskiem bocznym po prawej',
  'fabric.editor.rowControl': 'Podświetl wiersz',
  'fabric.editor.rowDragHandle': 'Opcje wierszy',
  'fabric.editor.rowMovedDown': 'Przesunięto wiersz w dół do {index} z {total}',
  'fabric.editor.rowMovedUp': 'Przesunięto wiersz w górę do {index} z {total}',
  'fabric.editor.rowSelected': 'Wybrano wiersz {index} z {total}',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {Wstawiono wiersz} few {Wstawiono {count} wiersze} many {Wstawiono {count} wierszy} other {Wstawiono {count} wiersza}}',
  'fabric.editor.rowsAreRemoved':
    '{count, plural, one {Usunięto wiersz} few {Usunięto {count} wiersze} many {Usunięto {count} wierszy} other {Usunięto {count} wiersza}}',
  'fabric.editor.saveButton': 'Zapisz',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {Dostępny jest {itemsLength,number} wynik wyszukiwania. Użyj klawiszy strzałek w górę i w dół, aby przechodzić między opcjami. Naciśnij klawisz Enter, aby wybrać opcję.} few {Dostępne są {itemsLength,number} wyniki wyszukiwania. Użyj klawiszy strzałek w górę i w dół, aby przechodzić między opcjami. Naciśnij klawisz Enter, aby wybrać opcję.} many {Dostępnych jest {itemsLength,number} wyników wyszukiwania. Użyj klawiszy strzałek w górę i w dół, aby przechodzić między opcjami. Naciśnij klawisz Enter, aby wybrać opcję.} other {Dostępne jest {itemsLength,number} wyniku wyszukiwania. Użyj klawiszy strzałek w górę i w dół, aby przechodzić między opcjami. Naciśnij klawisz Enter, aby wybrać opcję.}}',
  'fabric.editor.selectColumnResize': 'Wybierz rozmiar kolumny',
  'fabric.editor.selectLanguage': 'Wybierz język',
  'fabric.editor.selectTableColumn': 'Wybierz kolumnę tabeli',
  'fabric.editor.selectTableRow': 'Wybierz wiersz tabeli',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'Wybierz aplikację',
  'fabric.editor.settingsLinks': 'Przejdź do preferencji łączy',
  'fabric.editor.shortEmptyNodePlaceholderText': 'Wpisz /, aby wstawić',
  'fabric.editor.shortcut': 'Skrót tekstu',
  'fabric.editor.single': 'Układ jednokolumnowy',
  'fabric.editor.singleColumns': 'Układ 1-kolumnowy',
  'fabric.editor.sortColumnASC': 'Sortuj kolumnę A → Z',
  'fabric.editor.sortColumnDESC': 'Sortuj kolumnę Z → A',
  'fabric.editor.sortColumnDecreasing': 'Sortuj malejąco',
  'fabric.editor.sortColumnIncreasing': 'Sortuj rosnąco',
  'fabric.editor.splitCell': 'Podziel komórkę',
  'fabric.editor.status': 'Status',
  'fabric.editor.status.description': 'Dodaj niestandardową etykietę statusu',
  'fabric.editor.statusPlaceholder': 'Ustaw status',
  'fabric.editor.story': 'Historyjka',
  'fabric.editor.strike': 'Przekreślenie',
  'fabric.editor.subTask': 'Zadanie podrzędne',
  'fabric.editor.subscript': 'Przypis dolny',
  'fabric.editor.subscript.off.superscript.on': 'Indeks dolny wył., indeks górny wł.',
  'fabric.editor.success': 'Sukces',
  'fabric.editor.successPanel': 'Panel sukcesów',
  'fabric.editor.successPanel.description': 'Dodaj wskazówki w kolorze',
  'fabric.editor.superscript': 'Przypis górny',
  'fabric.editor.superscript.off.subscript.on': 'Indeks górny wył., indeks dolny wł.',
  'fabric.editor.supportAltText':
    'Tekst alternatywny jest przydatny dla osób z zaburzeniami widzenia, korzystających z czytników ekranowych.',
  'fabric.editor.table': 'Tabela',
  'fabric.editor.table.description': 'Wstaw tabelę',
  'fabric.editor.tableAlignmentOptions': 'Opcje wyrównania',
  'fabric.editor.tableFullWidthLabel': 'Pełna szerokość',
  'fabric.editor.tableHeader.sorting.asc': 'Posortowano rosnąco',
  'fabric.editor.tableHeader.sorting.default': 'Sortuj kolumnę',
  'fabric.editor.tableHeader.sorting.desc': 'Posortowano malejąco',
  'fabric.editor.tableHeader.sorting.invalid': 'Nie można sortować tabeli ze scalonymi komórkami',
  'fabric.editor.tableHeader.sorting.no': 'Do kolumny nie zastosowano żadnego sortowania',
  'fabric.editor.tableOptions': 'Opcje tabeli',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {Szerokość tabeli została zmniejszona do {newWidth,number} piksela.} few {Szerokość tabeli została zmniejszona do {newWidth,number} pikseli.} many {Szerokość tabeli została zmniejszona do {newWidth,number} pikseli.} other {Szerokość tabeli została zmniejszona do {newWidth,number} piksela.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {Szerokość tabeli została zwiększona do {newWidth,number} piksela.} few {Szerokość tabeli została zwiększona do {newWidth,number} pikseli.} many {Szerokość tabeli została zwiększona do {newWidth,number} pikseli.} other {Szerokość tabeli została zwiększona do {newWidth,number} piksela.}}',
  'fabric.editor.tableSelector': 'Rozmiar tabeli',
  'fabric.editor.tableSelector.description':
    'Dodaj tabelę za pomocą wyskakującego okienka, aby wybrać niestandardowy rozmiar.',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} na {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Selektor rozmiaru tabeli',
  'fabric.editor.tables.adjustColumn': 'Dostosuj kolumnę',
  'fabric.editor.tables.columnResizeLast': 'Rozmiar tej kolumny można zmienić tylko w lewo.',
  'fabric.editor.tables.columnResizeOverflow':
    'Rozmiar tej kolumny można zmienić tylko wtedy, gdy tabela ma pasek przewijania.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Szerokość kolumny została zmieniona na {width} piksel} few {Szerokość kolumny została zmieniona na {width} piksele} many {Szerokość kolumny została zmieniona na {width} pikseli} other {Szerokość kolumny została zmieniona na {width} piksela}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'Usunięcie rozszerzenia {nodeName} spowoduje uszkodzenie wszystkiego, co jest z nim połączone.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Usuń',
  'fabric.editor.tables.resizeStop': 'Zatrzymano zmianę rozmiaru',
  'fabric.editor.tables.resizeTable': 'Zmień rozmiar tabeli',
  'fabric.editor.tables.startedColumnResize': 'Rozpoczęto zmianę rozmiaru kolumny',
  'fabric.editor.task': 'Zadanie',
  'fabric.editor.taskPlaceholder': 'Wprowadź swoją akcję, użyj „@”, aby przypisać ją do użytkownika.',
  'fabric.editor.text.formatting.off': 'Formatowanie tekstu wył.',
  'fabric.editor.textColor': 'Kolor tekstu: {selectedColorName}',
  'fabric.editor.textColorTooltip': 'Kolor tekstu',
  'fabric.editor.textFormat': 'Formatuj tekst',
  'fabric.editor.textFormatting': 'Formatowanie tekstu',
  'fabric.editor.textStyles': 'Style tekstu: {blockTypeName}',
  'fabric.editor.textStylesTooltip': 'Style tekstu',
  'fabric.editor.threeColumns': 'Układ 3-kolumnowy',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Układ trzykolumnowy z paskiem bocznym z lewej strony',
  'fabric.editor.threeColumnsWithRightSidebars': 'Układ trzykolumnowy z paskiem bocznym z prawej strony',
  'fabric.editor.threeColumnsWithSidebars': 'Układ trzykolumnowy z paskami bocznymi',
  'fabric.editor.time.ago': 'temu',
  'fabric.editor.time.updated': 'Zaktualizowano',
  'fabric.editor.time.viewed': 'Wyświetlono',
  'fabric.editor.toolbarAppears': 'Położenie paska narzędzi',
  'fabric.editor.toolbarLabel': 'Edytor',
  'fabric.editor.toolbarMediaTitle': 'Dodaj obraz, film lub plik',
  'fabric.editor.toolbarPositionFixedAtTop': 'Nieruchomy na górze',
  'fabric.editor.tooltip.blockPanel': 'panel',
  'fabric.editor.tooltip.bulletList': 'lista',
  'fabric.editor.tooltip.decisionList': 'lista decyzji',
  'fabric.editor.tooltip.defaultBlockNode': 'węzeł bloku',
  'fabric.editor.tooltip.nestedExpand': 'zagnieżdżony węzeł rozwijany',
  'fabric.editor.tooltip.taskList': 'czynność do wykonania',
  'fabric.editor.turnInto': 'Zmień w',
  'fabric.editor.twoColumns': 'Układ 2-kolumnowy',
  'fabric.editor.typeAhead.popupLabel': 'Wyniki autouzupełniania',
  'fabric.editor.typeAhead.quickInsertInputLabel': 'Zacznij pisać, aby wyszukać lub filtrować opcje skrótów',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Wyszukaj',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Skróty do wstawiania i formatowania',
  'fabric.editor.typeahead.emojiInputLabel': 'Zacznij pisać, aby wyszukać lub filtrować opcje emoji',
  'fabric.editor.typeahead.emojiListItemLabel': 'Emoji {name} — skrót tekstowy {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Skróty emoji',
  'fabric.editor.typeahead.mentionInputLabel': 'Zacznij pisać, aby wyszukać użytkowników do otagowania',
  'fabric.editor.typeahead.mentionPopupLabel': 'Użytkownicy, których możesz otagować',
  'fabric.editor.typeahead.metionListItemLabel': 'Użytkownik {name} — @{shortName}',
  'fabric.editor.unableToLoadContent': 'Nie można załadować tej zawartości',
  'fabric.editor.unableToOpenLink': 'Nie można otworzyć tego łącza',
  'fabric.editor.underline': 'Podkreślenie',
  'fabric.editor.undo': 'Cofnij',
  'fabric.editor.unknown.label': 'Nieznany',
  'fabric.editor.unlink': 'Usuń łącze',
  'fabric.editor.unorderedList': 'Lista wypunktowana',
  'fabric.editor.unorderedList.description': 'Utwórz nieuporządkowaną listę',
  'fabric.editor.unsupportedBlockContent': 'Ten edytor nie obsługuje wyświetlania tej zawartości',
  'fabric.editor.unsupportedContentTooltip':
    'Zawartość jest niedostępna w tym edytorze, ale zostanie zachowana, jeśli ją wprowadzisz i zapiszesz',
  'fabric.editor.unsupportedInlineContent': 'Nieobsługiwana zawartość',
  'fabric.editor.upDown':
    'Data wprowadzona w poniższym polu za pomocą klawiszy strzałek w górę i w dół zostanie zaktualizowana poniżej',
  'fabric.editor.url': 'Wyświetl adres URL',
  'fabric.editor.urlDescription': 'Wyświetl łącze jako adres URL',
  'fabric.editor.urlTitle': 'Adres URL',
  'fabric.editor.useMarkdown': 'Użyj Markdown',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Wyświetl i dodaj komentarze',
  'fabric.editor.viewCommentOnMedia': 'Wyświetl komentarze',
  'fabric.editor.viewMore': 'Wyświetl więcej',
  'fabric.editor.visit': 'Otwórz łącze w nowym oknie',
  'fabric.editor.warning': 'Ostrzeżenie',
  'fabric.editor.warningPanel': 'Panel ostrzeżeń',
  'fabric.editor.warningPanel.description': 'Dodaj ostrzeżenie w kolorze',
  'fabric.editor.wrapLeft': 'Zawijaj do lewej',
  'fabric.editor.wrapRight': 'Zawijaj do prawej',
  'fabric.emoji.label': 'Emoji',
  'fabric.theme.blue': 'Niebieski',
  'fabric.theme.bold-blue': 'Intensywny niebieski',
  'fabric.theme.bold-gray': 'Intensywny szary',
  'fabric.theme.bold-green': 'Intensywny zielony',
  'fabric.theme.bold-magenta': 'Intensywna magenta',
  'fabric.theme.bold-orange': 'Intensywny pomarańczowy',
  'fabric.theme.bold-purple': 'Intensywny fioletowy',
  'fabric.theme.bold-red': 'Intensywny czerwony',
  'fabric.theme.bold-teal': 'Intensywny morski',
  'fabric.theme.bold-yellow': 'Intensywny żółty',
  'fabric.theme.bolder-blue': 'Intensywniejszy niebieski',
  'fabric.theme.bolder-gray': 'Intensywniejszy szary',
  'fabric.theme.bolder-green': 'Intensywniejszy zielony',
  'fabric.theme.bolder-magenta': 'Intensywniejsza magenta',
  'fabric.theme.bolder-orange': 'Intensywniejszy pomarańczowy',
  'fabric.theme.bolder-purple': 'Intensywniejszy fioletowy',
  'fabric.theme.bolder-red': 'Intensywniejszy czerwony',
  'fabric.theme.bolder-teal': 'Intensywniejszy morski',
  'fabric.theme.bolder-yellow': 'Intensywniejszy żółty',
  'fabric.theme.dark-blue': 'Ciemnoniebieski',
  'fabric.theme.dark-gray': 'Ciemnoszary',
  'fabric.theme.dark-green': 'Ciemnozielony',
  'fabric.theme.dark-purple': 'Ciemnofioletowy',
  'fabric.theme.dark-red': 'Ciemnoczerwony',
  'fabric.theme.dark-teal': 'Ciemnozielononiebieski',
  'fabric.theme.dark-yellow': 'Ciemnożółty',
  'fabric.theme.default': 'Domyślny',
  'fabric.theme.gray': 'Szary',
  'fabric.theme.green': 'Zielony',
  'fabric.theme.light-blue': 'Jasnoniebieski',
  'fabric.theme.light-gray': 'Jasnoszary',
  'fabric.theme.light-green': 'Jasnozielony',
  'fabric.theme.light-purple': 'Jasnofioletowy',
  'fabric.theme.light-red': 'Jasnoczerwony',
  'fabric.theme.light-teal': 'Jasnomorski',
  'fabric.theme.light-yellow': 'Jasnożółty',
  'fabric.theme.lime': 'Limonkowy',
  'fabric.theme.magenta': 'Magenta',
  'fabric.theme.no-color': 'Bez wyróżnienia',
  'fabric.theme.orange': 'Pomarańczowy',
  'fabric.theme.purple': 'Fioletowy',
  'fabric.theme.red': 'Czerwony',
  'fabric.theme.subtle-blue': 'Subtelny niebieski',
  'fabric.theme.subtle-gray': 'Subtelny szary',
  'fabric.theme.subtle-green': 'Subtelny zielony',
  'fabric.theme.subtle-magenta': 'Subtelna magenta',
  'fabric.theme.subtle-orange': 'Subtelny pomarańczowy',
  'fabric.theme.subtle-purple': 'Subtelny fioletowy',
  'fabric.theme.subtle-red': 'Subtelny czerwony',
  'fabric.theme.subtle-teal': 'Subtelny turkusowy',
  'fabric.theme.subtle-yellow': 'Subtelny żółty',
  'fabric.theme.teal': 'Morski',
  'fabric.theme.white': 'Biały',
  'fabric.theme.yellow': 'Żółty',
  'fabrid.editor.rowNumbers': 'Numery wierszy',
  'rovo.agents.dropdown.title': 'Agenty',
  'rovo.agents.dropdown.viewAgents.label': 'Wyświetl wszystkie agenty',
};
